const state = {
  alerts: [],
  id: 0
}

const getters = {
  alertList: state => state.alerts
}

const actions = {
  pushAlert ({commit, state}, {message, type}) {
    commit(
      'add',
      {
        message: message,
        type: type
      }
    )
  },
  removeAlert ({commit, state}, {id}) {
    commit(
      'remove',
      {
        id: id
      }
    )
  },
  clearAlerts ({commit, state}) {
    commit(
      'clear'
    )
  }
}

const mutations = {
  add (state, {message, type}) {
    state.id += 1
    var alert = {
      'id': state.id,
      'message': message,
      'type': type
    }
    state.alerts.push(alert)
  },
  remove (state, {id}) {
    var index = state.alerts.findIndex(x => {
      return x.id === id
    })
    if (index !== -1) state.alerts.splice(index, 1)
  },
  clear (state) {
    state.alerts = []
    state.id = 0
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
